import { $color_brand_bg_default, $color_brand_border_hover, $color_grey_9 } from '../pebbleGlobalToken/color.js';

/**
 * 滑动输入条-浮层容器背景色，在暗色模式下该 token 的色值会比 `colorBgContainer` 要亮一些。例如：模态框、弹出框、菜单等。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_bg_default
 */
var $slider_color_bg_elevated = $color_brand_bg_default;

/**
 * 滑动输入条-主色梯度下的描边用色，用在 Slider 等组件的描边上。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_border_hover
 */
var $slider_color_primary_border = $color_brand_border_hover;

/**
 * 滑动输入条-轨道已覆盖部分背景色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_grey_9
 */
var $slider_color_track = $color_grey_9;

export { $slider_color_bg_elevated, $slider_color_primary_border, $slider_color_track };
